import { useMutation, useQueryClient } from '@tanstack/vue-query';
import { getApi } from '../api';
import type { ShipmentExceptionRow } from '../shipment-exception-types';

export type PostAccountExceptionsBulkReopenVariables = {
  accountId: number;
  exceptionIds: number[];
};

export type BulkReopenExceptionsResult = {
  data: ShipmentExceptionRow[];
  errors: Array<{ id: number; message: string }>;
};

export default function usePostAccountExceptionsBulkReopen() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      accountId,
      exceptionIds,
    }: PostAccountExceptionsBulkReopenVariables): Promise<BulkReopenExceptionsResult> => {
      const { api, baseURL } = getApi();
      const res = await api.post(
        `/api/v2/accounts/${accountId}/exceptions/bulk/reopen`,
        { exception_ids: exceptionIds },
        { baseURL },
      );
      return {
        data: (res.data?.data ?? []) as ShipmentExceptionRow[],
        errors: (res.data?.errors ?? []) as Array<{
          id: number;
          message: string;
        }>,
      };
    },
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['account-exceptions', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-exception-metrics', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-shipment-exceptions', variables.accountId],
      });
      queryClient.invalidateQueries({
        queryKey: ['account-shipments', variables.accountId],
      });
    },
  });
}
